module.exports = __webpack_public_path__ + "media/images/Give2Asia_hires-a4ce80432102a36eba64f7f77c90fb17.png";